export default __webpack_public_path__ + "static/media/primary.2eeac7ca1817cad1b9293f3c8e8a373a.svg";